import { render, staticRenderFns } from "./Insight_Count.vue?vue&type=template&id=e36fa000&scoped=true"
import script from "./Insight_Count.vue?vue&type=script&lang=js"
export * from "./Insight_Count.vue?vue&type=script&lang=js"
import style0 from "./Insight_Count.vue?vue&type=style&index=0&id=e36fa000&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e36fa000",
  null
  
)

export default component.exports